module.exports = __webpack_public_path__ + "img/testdrive.1cfc46e7.svg";